import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PieChart from "./PieChart";

const PivotablePieChart = ({ title, usages, groupBy, countBy, hollow = false, InnerTextComponent = null, onClick = () => {}, maxSlices = 7, SideContent = null, collapsibleSideContent = false, sideContentDefaultOpen = true }) => {
  const [data, setData] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    const grouped = {};

    usages.forEach((u) => {
      const key = `${u[groupBy]}`;
      if (!grouped[key]) grouped[key] = 0;
      if (countBy) {
        grouped[key] += u[countBy];
      } else {
        grouped[key] += 1;
      }
    });
    const chartData = Object.entries(grouped).map(([label, value]) => ({ label, value }));

    if (maxSlices && chartData.length > maxSlices) {
      const sorted = [...chartData].sort((a, b) => b.value - a.value);
      const topItems = sorted.slice(0, maxSlices - 1);
      const remaining = sorted.slice(maxSlices - 1);
      const othersValue = remaining.reduce((sum, item) => sum + item.value, 0);

      const finalData = [...topItems];
      if (othersValue > 0) {
        finalData.push({ label: t("Others"), value: othersValue, isOthers: true });
      }
      setData(finalData);
    } else {
      setData(chartData);
    }
  }, [usages, groupBy, countBy, maxSlices, t]);

  return <PieChart title={title} data={data} hollow={hollow} InnerTextComponent={InnerTextComponent} onClick={onClick} SideContent={SideContent} collapsibleSideContent={collapsibleSideContent} sideContentDefaultOpen={sideContentDefaultOpen} />;
};

export default PivotablePieChart;
